import { toast } from "sonner";
import { MessageCircle, Link as LinkIcon } from "lucide-react";
import { API } from "@/lib/api";

// Shares a branded preview link (/api/share/...) that WhatsApp & socials render as a card.
export const ShareButtons = ({ kind, id, text, className = "", testPrefix = "share" }) => {
  const url = `${API}/share/${kind}/${id}`;
  const message = `${text}\n${url}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — paste it into any chat");
    } catch {
      toast(url);
    }
  };
  const btn = "lab inline-flex items-center gap-2 border border-current/30 px-4 py-2 transition-colors duration-200 hover:bg-white/10";
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid={`${testPrefix}-row`}>
      <span className="lab opacity-60 mr-1">Share</span>
      <a href={`https://wa.me/?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer"
        data-testid={`${testPrefix}-whatsapp`} className={btn}>
        <MessageCircle size={14} /> WhatsApp
      </a>
      <button type="button" onClick={copy} data-testid={`${testPrefix}-copy`} className={btn}>
        <LinkIcon size={14} /> Copy link
      </button>
    </div>
  );
};
